import {DeleteMeConfirmation} from "./DeleteMeConfirmation"

export default DeleteMeConfirmation
